import React, { Component } from 'react';
import { connect } from 'react-redux';
import uuid from 'uuid';

import moment from 'moment';

import {
	Button,
	ButtonGroup,
	Tooltip,
	Icon,
	Checkbox,
} from '@blueprintjs/core';

import { ResultHeader, ResultHeaderWithSort, Result, MultiSelectFilter, DateRangeFilter, TextFilter } from '../code_tables/ResultComponents';
import Reservation from '../reservations/Reservation';

import { addInvoice, addInvoices, addAdvanceInvoiceConsumptions }    from '../../slices/BusinessSlice';
import { saveInvoice, loadInvoices, loadAdvanceInvoiceConsumptions } from '../../api/Business';
import { addDocumentAssociations }                                   from '../../slices/DocumentSlice';
import EditInvoiceDialog                                             from '../business/EditInvoiceDialog';
import WaitFiscalVerificationDialog                                  from '../business/WaitFiscalVerificationDialog';
import InvoiceCreator                                                from '../../helpers/InvoiceCreator';
import DocumentListDialog                                            from '../DocumentListDialog';

import { enqueueInvoiceOnA4PrinterQueue, enqueueInvoiceOnPosPrinterQueue } from '../../slices/AppSlice';

function Documents(props) {
	if (props.documents.length == 0) return null;
	
	let items = [];
	
	const document = props.documents[0];
	let id_document   = document.id_document;
	let document_type = document.document_type;
	
	let document_document_number = null;
	let document_click_handler   = null;
	
	if (document_type == 'cash-invoice' || document_type == 'invoice' || document_type == 'offer' ||
		document_type == 'prepayment-invoice' || document_type == 'credit-note') {
		const invoice_item = props.invoices[id_document];
		if (invoice_item !== undefined) {
			document_document_number = invoice_item.invoice_number_internal;
			
			document_click_handler = () => {
				props.openEditInvoiceDialog(invoice_item.invoice_type, invoice_item);
			};
		}
	}
	items.push(<Button
		key='latest-document'
		small={true}
		className='cell-button'
		onClick={document_click_handler}>
		{document_document_number}
	</Button>);
	
	if (props.documents.length > 1) {
		items.push(<Button
			key='more-documents'
			small={true}
			className='cell-button ml-1'
			onClick={props.openDocumentListDialog}
			icon='multi-select' />);
	}
	
	return items;
}

function Results(props) {
	const {
		table_items,
		table_items_sort_ids,
		table_items_sort_field,
		table_items_sort_direction,
		setTableItemsSort,
		tableItemsFilters,
		originalTableItemsFilters,
		handleFilterChange,
		customers,
		reservation_customers,
		accommodations,
		accommodation_items,
		accommodation_item_places,
		countries,
		accommodation_item_place_titles,
		statuses,
		identification_types,
		openReservationDialog,
		guest_book_items,
		document_associations,
		invoices,
		openEditInvoiceDialog,
		expanded,
		openDocumentListDialog,
	} = props;
	
	const sort_props = {
		setTableItemsSort:       setTableItemsSort,
		tableItemsSortField:     table_items_sort_field,
		tableItemsSortDirection: table_items_sort_direction,
	};
	
	const toLocalString = date => {
		if (date === null || date === undefined) return '';
		
		if (!(date instanceof Date)) return date;
		
		return date.getDate().toString().padStart(2, '0') + '.' +
			(date.getMonth() + 1).toString().padStart(2, '0') + '.' +
			date.getFullYear();
	};
	const toLocalStringWithTime = date => {
		if (date === null) return '';
		
		return date.getDate().toString().padStart(2, '0') + '.' +
			(date.getMonth() + 1).toString().padStart(2, '0') + '.' +
			date.getFullYear() + ' ' +
			date.getHours().toString().padStart(2, '0') + ':' +
			date.getMinutes().toString().padStart(2, '0') + ':' +
			date.getSeconds().toString().padStart(2, '0');
	};
	
	const items_id_accommodation_item_places = [];
	for (let id in table_items) {
		const id_accommodation_item_place = table_items[id].id_accommodation_item_place;
		if (items_id_accommodation_item_places.indexOf(id_accommodation_item_place) == -1) {
			items_id_accommodation_item_places.push(id_accommodation_item_place);
		}
	}
	
	const accommodation_item_place_items = {};
	for (let id_accommodation in accommodations) {
		for (let id_accommodation_item in accommodation_items) {
			if (accommodation_items[id_accommodation_item].id_accommodation != id_accommodation) continue;
			
			for (let id_accommodation_item_place in accommodation_item_places) {
				if (accommodation_item_places[id_accommodation_item_place].id_accommodation_item != id_accommodation_item) continue;
				
				// only display used ones
				if (items_id_accommodation_item_places.indexOf(id_accommodation_item_place) == -1) continue;
				
				let title = accommodations[id_accommodation].title + ' • ';
				if (accommodation_items[id_accommodation_item].title != 'default') {
					title += accommodation_items[id_accommodation_item].title + ' • ';
				}
				title += accommodation_item_places[id_accommodation_item_place].title;
				
				accommodation_item_place_items[id_accommodation_item_place] = {
					id_accommodation_item_place,
					title,
					ord:
						accommodations[id_accommodation].ord * 1000000 +
						accommodation_items[id_accommodation_item].ord * 10000 +
						accommodation_item_places[id_accommodation_item_place].ord,
				};
			}
		}
	}
	
	const customer_countries = {};
	for (let id_customer in customers) {
		const id_country = customers[id_customer].id_country;
		if (customer_countries[id_country] !== undefined) continue;
		
		customer_countries[id_country] = {
			id_country,
			title: countries[id_country] === undefined ? '' : countries[id_country].common_name_local,
		};
	}
	
	const identification_type_obj = {};
	for (let id_identification_type in identification_types) {
		identification_type_obj[id_identification_type] = {
			id_identification_type,
			title: identification_types[id_identification_type].title,
			ord:   identification_types[id_identification_type].ord,
		};
	}
	
	const reservation_customers_by_id_reservations = {};
	for (let id_reservation_customer in reservation_customers) {
		const reservation_customer = reservation_customers[id_reservation_customer];
		
		if (reservation_customers_by_id_reservations[reservation_customer.id_reservation] === undefined) {
			reservation_customers_by_id_reservations[reservation_customer.id_reservation] = [];
		}
		
		reservation_customers_by_id_reservations[reservation_customer.id_reservation].push(reservation_customer);
	}
	
	const etourism_statuses = {
		none:    'NEPOSLAN',
		waiting: 'ČAKA NA POŠILJANJE',
		success: 'POSLANO USPEŠNO',
		failure: 'NAPAKA PRI POŠILJANJU',
	};
	const etourism_status_colors = {
		none:    '#cccccc',
		waiting: 'orange',
		success: 'green',
		failure: 'red',
	};
	
	const getDocuments = (id_document, max_depth, depth) => {
		depth = depth || 1;
		
		let items = {};
		if (depth > max_depth) return items;
		
		let documents = Object.values(document_associations[id_document] || {});
		
		for (let i=0; i<documents.length; i++) {
			let item = documents[i];
			let curr_id_document = item.source_id_document;
			let document_type    = item.source_type;
			
			if (item.source_id_document == id_document) {
				curr_id_document = item.target_id_document;
				document_type    = item.target_type;
			}
			
			if (items[item.id_document_association] === undefined) {
				items[item.id_document_association] = {
					id_document_association: item.id_document_association,
					created:                 item.created,
					id_document:             curr_id_document,
					document_type,
				};
			}
			
			const subitems = getDocuments(curr_id_document, max_depth, depth + 1);
			for (let id_document_association in subitems) {
				if (items[id_document_association] === undefined) {
					items[id_document_association] = subitems[id_document_association];
				}
			}
		}
		
		return items;
	};
	
	let columnIdx        = 1;
	let filtersColumnIdx = 1;
	
	let total_guest_adult_count   = 0;
	let total_guest_child_1_count = 0;
	let total_guest_child_2_count = 0;
	
	return <>
		<div className='results mt-4 mb-2'>
			<div className='results-table without-vertical-lines'>
				<ResultHeader columnIdx={columnIdx++} title='' />
				<ResultHeader columnIdx={columnIdx++} title='' />
				<ResultHeaderWithSort
					columnIdx={columnIdx++} {...sort_props} title='Objekt' fieldName='accommodation' />
				<ResultHeaderWithSort
					columnIdx={columnIdx++} {...sort_props} title='Status' fieldName='status' />
				<ResultHeaderWithSort
					columnIdx={columnIdx++} {...sort_props} title='Šifra' fieldName='internal_code' />
				<ResultHeaderWithSort
					columnIdx={columnIdx++} {...sort_props} title='Nosilec / gosti' fieldName='guests' />
				<ResultHeaderWithSort
					columnIdx={columnIdx++} {...sort_props} title='Država' fieldName='customer_id_country' />
				<ResultHeaderWithSort
					columnIdx={columnIdx++} {...sort_props} title='Osebni dokument' fieldName='customer_id_identification_type' />
				<ResultHeaderWithSort
					columnIdx={columnIdx++} {...sort_props} title='Št. dokumenta' fieldName='customer_identification_number' />
				<ResultHeader columnIdx={columnIdx++} title='Prihod' />
				<ResultHeader columnIdx={columnIdx++} title='Odhod' />
				<ResultHeaderWithSort
					columnIdx={columnIdx++} {...sort_props} title='Osebe' fieldName='guest_count' />
				<ResultHeader columnIdx={columnIdx++} title='Prijavljeni' />
			</div>
			
			<div className='results-table without-vertical-lines filters-row'>
				<Result columnIdx={filtersColumnIdx++} />
				<Result columnIdx={filtersColumnIdx++} />
				<Result columnIdx={filtersColumnIdx++} child={
					<div className='flex flex-row'>
						<MultiSelectFilter
							empty_title    ='Izberi'
							value_field    ='id_accommodation_item_place'
							title_field    ='title'
							items          ={accommodation_item_place_items}
							displaySort    ={(a, b) => a.ord - b.ord}
							filtered_keys  ={tableItemsFilters.id_accommodation_item_places}
							onFilterChange ={values => handleFilterChange('id_accommodation_item_places', values)} />
					</div>
				} />
				<Result columnIdx={filtersColumnIdx++} child={
					<div className='flex flex-row'>
						<MultiSelectFilter
							empty_title    ='Izberi'
							value_field    ='key'
							title_field    ='title'
							items          ={statuses}
							filtered_keys  ={tableItemsFilters.statuses}
							onFilterChange ={values => handleFilterChange('statuses', values)} />
					</div>
				} />
				<Result columnIdx={filtersColumnIdx++} child={
					<TextFilter
						value={tableItemsFilters.internal_code}
						onChange={ event => handleFilterChange('internal_code', event) } />
				} />
				<Result columnIdx={filtersColumnIdx++} child={
					<TextFilter
						value={tableItemsFilters.customer_name}
						onChange={ event => handleFilterChange('customer_name', event) } />
				} />
				<Result columnIdx={filtersColumnIdx++} child={
					<div className='flex flex-row'>
						<MultiSelectFilter
							empty_title    ='Izberi'
							value_field    ='id_country'
							title_field    ='title'
							items          ={customer_countries}
							filtered_keys  ={tableItemsFilters.customer_id_countries}
							onFilterChange ={values => handleFilterChange('customer_id_countries', values)} />
					</div>
				} />
				<Result columnIdx={filtersColumnIdx++} child={
					<div className='flex flex-row'>
						<MultiSelectFilter
							empty_title    ='Izberi'
							value_field    ='id_identification_type'
							title_field    ='title'
							items          ={identification_type_obj}
							filtered_keys  ={tableItemsFilters.customer_id_identification_types}
							displaySort    ={(a, b) => a.ord - b.ord}
							onFilterChange ={values => handleFilterChange('customer_id_identification_types', values)} />
					</div>
				} />
				<Result columnIdx={filtersColumnIdx++} child={
					<TextFilter
						value={tableItemsFilters.customer_identification_number}
						onChange={ event => handleFilterChange('customer_identification_number', event) } />
				} />
				<Result columnIdx={filtersColumnIdx++} child={
					<DateRangeFilter
						filter_values={tableItemsFilters.check_in_range}
						short_year={true}
						original_start_date={originalTableItemsFilters.check_in_range[0]}
						original_end_date={originalTableItemsFilters.check_in_range[1]}
						onFilterChange={values => handleFilterChange('check_in_range', values)} />
				} {...sort_props} />
				<Result columnIdx={filtersColumnIdx++} child={
					<DateRangeFilter
						filter_values={tableItemsFilters.check_out_range}
						short_year={true}
						original_start_date={originalTableItemsFilters.check_out_range[0]}
						original_end_date={originalTableItemsFilters.check_out_range[1]}
						onFilterChange={values => handleFilterChange('check_out_range', values)} />
				} {...sort_props} />
				<Result columnIdx={filtersColumnIdx++} />
				<Result columnIdx={filtersColumnIdx++} child={
					<Checkbox
						checked={tableItemsFilters.guests_checked_in === true}
						indeterminate={tableItemsFilters.guests_checked_in === null}
						onChange={event => {
							let checked = true;
							if (tableItemsFilters.guests_checked_in === true) {
								checked = null;
							}
							else if (tableItemsFilters.guests_checked_in === null) {
								checked = false;
							}
							
							handleFilterChange('guests_checked_in', checked);
						}} />
				} />
			</div>
			
			{table_items_sort_ids.map((id, idx) => {
				const item     = table_items[id];
				const customer = customers[item.id_customer] ?? null;
				
				const documents = Object.values(getDocuments(
					item.id_reservation,
					3
				)).sort((a, b) => { // sort by created, descending
					if (a.created < b.created) return  1;
					if (a.created > b.created) return -1;
					return 0;
				}).filter(document => document.document_type == 'invoice' || document.document_type == 'cash-invoice');
				
				let pattern_class_name = '';
				if (item.status == 'offer-sent') {
					pattern_class_name = 'reservation-list-pattern-polka-dots';
				}
				else if (item.status == 'advance-invoice-sent' || item.status == 'not-for-rent' /*with red background*/) {
					pattern_class_name = 'reservation-list-pattern-diagonal-stripes';
				}
				
				total_guest_adult_count   += item.guest_adult_count;
				total_guest_child_1_count += item.guest_child_1_count;
				total_guest_child_2_count += item.guest_child_2_count;
				
				columnIdx = 1;
				
				return <div
					className={
						'results-table' +
						' ' +
						'without-vertical-lines' +
						' ' +
						'status-' + (item.deleted === true ? 'deleted' : item.status) +
						' ' +
						(item.status_2 === null ? '' : item.status_2)
					}
					key={'result--result-' + id}>
					<svg version='1.1'
						baseProfile='full'
						width='16' height='16'
						className='custom-status'
						xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M 0,0 L 16,0 L 0,16 L 0,0 z'
							fill='#ff0000' />
					</svg>
					
					<Result columnIdx={columnIdx++} child={
						<Button
							icon='edit'
							intent='primary'
							minimal={true}
							small={true}
							onClick={() => openReservationDialog(item.id_reservation)} />
					} />
					<Result columnIdx={columnIdx++} child={
						pattern_class_name == '' ? null : <div className={pattern_class_name} />
					} />
					<Result columnIdx={columnIdx++} child={
						accommodation_item_place_titles[item.id_accommodation_item_place]
					} />
					<Result columnIdx={columnIdx++} child={
						statuses[item.deleted === true ? 'deleted' : item.status].title
					} />
					<Result columnIdx={columnIdx++} child={
						item.internal_code
					} />
					<Result columnIdx={columnIdx++} child={
						<div>
							<div className='one-line-minimum'>{
								item.id_customer === null || customers[item.id_customer] === undefined ? null :
									<div className='grid grid-cols-2'>
										<div><strong>
											{
												customers[item.id_customer].type == 'natural' ?
													customers[item.id_customer].surname + ' ' + customers[item.id_customer].name
													:
													customers[item.id_customer].company_name
											}
										</strong></div>
										<div className='text-right'>{
											<Documents
												documents={documents}
												invoices={invoices}
												openEditInvoiceDialog={openEditInvoiceDialog}
												openDocumentListDialog={() => {
													openDocumentListDialog(item.id_reservation);
												}} />
										}</div>
									</div>
							}</div>
							
							{!expanded ? null :
								<div className='reservation-list-guests-table'>
									{reservation_customers_by_id_reservations[id] === undefined ? null :
										Object.values(reservation_customers_by_id_reservations[id]).map(reservation_customer => {
											const customer = customers[reservation_customer.id_customer];
											if (customer === undefined || customer === null) return null;
											
											const guest_book_item = guest_book_items[reservation_customer.id_guest_book];
											
											const etourism_status_title = etourism_statuses[
												guest_book_item === undefined || guest_book_item.zst === null || guest_book_item.etourism_status === null ?
													'none' : guest_book_item.etourism_status
											];
											const etourism_status_color = etourism_status_colors[
												guest_book_item === undefined || guest_book_item.zst === null || guest_book_item.etourism_status === null ?
													'none' : guest_book_item.etourism_status
											];
											
											const etourism_tooltip_content = <div>
												<div>Stanje: {etourism_status_title}</div>
												{guest_book_item === null ||
													guest_book_item === undefined ||
													guest_book_item.log === null ||
													guest_book_item.log.length == 0 ? null :
													<>
														<div className='mt-6 mb-1'>Dnevnik dogodkov:</div>
														{[...guest_book_item.log]
															.sort((log_item_a, log_item_b) => log_item_a.created.localeCompare(log_item_b.created) * -1)
															.map(guest_book_log => {
																let status_title = 'neznano';
																switch (guest_book_log.status) {
																	case 'success':
																		status_title  = 'POSLANO USPEŠNO';
																		break;
																	case 'failure':
																		status_title  = 'NAPAKA PRI POŠILJANJU';
																		break;
																}
																
																return <div key={'guest-book-log-' + guest_book_log.id_guest_book_log} style={{ maxWidth: 480, marginBottom: '1rem' }}>
																	<div className='flex flex-row justify-between mb-1'>
																		<div className='mr-12'>{status_title}</div>
																		<div>{new Date(guest_book_log.created).toLocaleString('sl-SI')}</div>
																	</div>
																	<div>
																		{
																			JSON.parse(guest_book_log.message)
																				.map(message_item => message_item.error_message)
																				.join(', ')
																		}
																	</div>
																</div>;
															})
														}
													</>
												}
											</div>;
											
											const documents = Object.values(getDocuments(
												reservation_customer.id_reservation_customer,
												1
											)).sort((a, b) => { // sort by created, descending
												if (a.created < b.created) return  1;
												if (a.created > b.created) return -1;
												return 0;
											}).filter(document => document.document_type == 'cash-invoice');
											
											return <React.Fragment key={'guest-' + reservation_customer.id_reservation_customer}>
												<div>
													<Button
														icon='edit'
														intent='primary'
														minimal={true}
														small={true}
														onClick={() => openReservationDialog(
															item.id_reservation, reservation_customer.id_reservation_customer
														)} />
													<Tooltip content={etourism_tooltip_content}>
														<Icon
															icon={reservation_customer.checked_out === false ? 'upload' : 'tick'}
															className='ml-1'
															color={etourism_status_color} />
													</Tooltip>
												</div>
												<div>{
													customer.type == 'natural' ?
														customer.surname + ' ' + customer.name
														:
														customer.company_name
												}</div>
												<div>{
													<Documents
														documents={documents}
														invoices={invoices}
														openEditInvoiceDialog={openEditInvoiceDialog}
														openDocumentListDialog={() => {
															openDocumentListDialog(item.id_reservation);
														}} />
												}</div>
											</React.Fragment>;
										})
									}
								</div>
							}
						</div>
					} />
					<Result columnIdx={columnIdx++} child={
						<div>
							<div className='one-line-minimum'><strong>{
								customer === null || customer.id_country === null || countries[customer.id_country] === undefined ? 
									'' : countries[customer.id_country].common_name_local}
							</strong></div>
							
							{!expanded ? null :
								<div className='reservation-list-guests'>
									{reservation_customers_by_id_reservations[id] === undefined ? null :
										Object.values(reservation_customers_by_id_reservations[id]).map(reservation_customer => {
											const customer = customers[reservation_customer.id_customer];
											if (customer === undefined || customer === null) return null;
											
											return <div key={'guest-' + reservation_customer.id_reservation_customer}>
												{customer.id_country === null ? '' : countries[customer.id_country].common_name_local}
											</div>;
										})
									}
								</div>
							}
						</div>
					} />
					<Result columnIdx={columnIdx++} child={
						<div>
							<div className='one-line-minimum'><strong>{
								customer === null || customer.id_identification_type === null ? '' :
									identification_types[customer.id_identification_type].title
							}</strong></div>
							
							{!expanded ? null :
								<div className='reservation-list-guests'>
									{reservation_customers_by_id_reservations[id] === undefined ? null :
										Object.values(reservation_customers_by_id_reservations[id]).map(reservation_customer => {
											const customer = customers[reservation_customer.id_customer];
											if (customer === undefined || customer === null) return null;
											
											return <div key={'guest-' + reservation_customer.id_reservation_customer}>
												{customer.id_identification_type === null ? '' : identification_types[customer.id_identification_type].title}
											</div>;
										})
									}
								</div>
							}
						</div>
					} />
					<Result columnIdx={columnIdx++} child={
						<div>
							<div className='one-line-minimum'><strong>{customer === null ? '' : customer.identification_number}</strong></div>
							
							{!expanded ? null :
								<div className='reservation-list-guests'>
									{reservation_customers_by_id_reservations[id] === undefined ? null :
										Object.values(reservation_customers_by_id_reservations[id]).map(reservation_customer => {
											const customer = customers[reservation_customer.id_customer];
											if (customer === undefined || customer === null) return null;
											
											return <div key={'guest-' + reservation_customer.id_reservation_customer}>
												{customer.identification_number}
											</div>;
										})
									}
								</div>
							}
						</div>
					} />
					<Result columnIdx={columnIdx++} child={
						<div>
							<div className='one-line-minimum'><strong>{toLocalString(new Date(item.check_in))}</strong></div>
							
							{!expanded ? null :
								<div className='reservation-list-guests'>
									{reservation_customers_by_id_reservations[id] === undefined ? null :
										Object.values(reservation_customers_by_id_reservations[id]).map(reservation_customer => {
											const customer = customers[reservation_customer.id_customer];
											if (customer === undefined || customer === null) return null;
											
											return <div key={'guest-' + reservation_customer.id_reservation_customer}>
												{toLocalStringWithTime(new Date(reservation_customer.check_in))}
											</div>;
										})
									}
								</div>
							}
						</div>
					} />
					<Result columnIdx={columnIdx++} child={
						<div>
							<div className='one-line-minimum'><strong>{toLocalString(new Date(item.check_out))}</strong></div>
							
							{!expanded ? null :
								<div className='reservation-list-guests'>
									{reservation_customers_by_id_reservations[id] === undefined ? null :
										Object.values(reservation_customers_by_id_reservations[id]).map(reservation_customer => {
											const customer = customers[reservation_customer.id_customer];
											if (customer === undefined || customer === null) return null;
											
											return <div key={'guest-' + reservation_customer.id_reservation_customer}>
												{toLocalStringWithTime(new Date(reservation_customer.check_out))}
											</div>;
										})
									}
								</div>
							}
						</div>
					} />
					<Result columnIdx={columnIdx++} child={
						item.guest_adult_count + ' / ' + (item.guest_child_1_count + item.guest_child_2_count)
					} />
					<Result columnIdx={columnIdx++} child={
						item.guests_checked_in === true
							? <Icon icon='tick' />
							: <Icon icon='cross' />
					} />
				</div>;
			})}
		</div>
		<div className='results borderless mb-4'>
			<div className='results-table'>
				<Result columnIdx={1} span={4} child={
					'Število zapisov: ' + table_items_sort_ids.length
				} />
				<Result columnIdx={5} child={''} />
				<Result columnIdx={6} child={''} />
				<Result columnIdx={7} child={''} />
				<Result columnIdx={8} child={''} />
				<Result columnIdx={9} child={''} />
				<Result columnIdx={10} child={''} />
				<Result columnIdx={11} child={''} />
				<Result columnIdx={12} cls='font-bold' child={
					total_guest_adult_count + ' / ' + (total_guest_child_1_count + total_guest_child_2_count)
				} />
				<Result columnIdx={13} child={''} />
			</div>
		</div>
	</>;
}

class ReservationList extends Component {
	constructor(props) {
		super(props);
		
		this._ismounted = false;
		
		this.updateTableItemsFromProps  = this.updateTableItemsFromProps .bind(this);
		this.setTableItemsSort          = this.setTableItemsSort         .bind(this);
		this.refreshTableItemsSort      = this.refreshTableItemsSort     .bind(this);
		this.filterTableItems           = this.filterTableItems          .bind(this);
		this.handleFilterChange         = this.handleFilterChange        .bind(this);
		this.openReservationDialog      = this.openReservationDialog     .bind(this);
		this.closeReservationDialog     = this.closeReservationDialog    .bind(this);
		this.openEditInvoiceDialog      = this.openEditInvoiceDialog     .bind(this);
		this.closeEditInvoiceDialog     = this.closeEditInvoiceDialog    .bind(this);
		this.generateAccommodationItemPlaceTitles = this.generateAccommodationItemPlaceTitles.bind(this);
		this.generateAccommodationItemPlaceOrds   = this.generateAccommodationItemPlaceOrds  .bind(this);
		this.openDocumentListDialog     = this.openDocumentListDialog    .bind(this);
		this.closeDocumentListDialog    = this.closeDocumentListDialog   .bind(this);
		
		const table_items_filters = {
			id_accommodation_item_places:     [],
			statuses:                         [],
			internal_code:                    '',
			customer_name:                    '',
			customer_id_countries:            [],
			customer_id_identification_types: [],
			customer_identification_number:   '',
			check_in_range:                   [null, null],
			check_out_range:                  [moment().toDate(), moment().toDate()],
			guests_checked_in:                null,
		};
		
		const accommodation_item_place_titles = this.generateAccommodationItemPlaceTitles(
			props.accommodations,
			props.accommodation_items,
			props.accommodation_item_places,
		);
		const accommodation_item_place_ords = this.generateAccommodationItemPlaceOrds(
			props.accommodations,
			props.accommodation_items,
			props.accommodation_item_places,
		);
		
		const {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
		} = this.updateTableItemsFromProps(props, {
			table_items_filters,
			table_items_sort_field: 'accommodation',
			table_items_sort_direction: 'ASC',
			accommodation_item_place_titles,
			accommodation_item_place_ords,
		});
		
		const statuses = {
			'new':                      { title: 'Nova',           key: 'new'                       },
			'waiting-for-confirmation': { title: 'V potrjevanju',  key: 'waiting-for-confirmation'  },
			'offer-sent':               { title: 'Izdana ponudba', key: 'offer-sent'                },
			'confirmed':                { title: 'Potrjena',       key: 'confirmed'                 },
			'advance-invoice-sent':     { title: 'Izdan avans',    key: 'advance-invoice-sent'      },
			'closed':                   { title: 'Plačana',        key: 'closed'                    },
			'reversed':                 { title: 'Stornirana',     key: 'reversed',                 },
			'no-show':                  { title: 'Neprihod',       key: 'no-show',                  },
			'not-for-rent':             { title: 'Ni za oddajo',   key: 'not-for-rent'              },
			'deleted':                  { title: 'Brisana',        key: 'deleted'                   },
		};
		
		this.state = {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
			table_items_sort_field: 'accommodation',
			table_items_sort_direction: 'ASC',
			table_items_filters,
			original_table_items_filters: {...table_items_filters},
			date_range_picker_dialog_open:        false,
			date_range_picker_dialog_filter_name: null,
			accommodation_item_place_titles,
			accommodation_item_place_ords,
			statuses,
			reservation_dialog_open:                    false,
			reservation_dialog_id_reservation:          -1,
			reservation_dialog_id_reservation_customer: null,
			invoice_dialog_open: false,
			invoice_dialog_item: null,
			invoice_dialog_type: '',
			expanded: false,
			document_list_dialog_open:        false,
			document_list_dialog_id_document: null,
			wait_fiscal_verification_dialog_open:       false,
			wait_fiscal_verification_dialog_id_invoice: null,
		};
	}
	
	componentDidMount() {
		this._ismounted = true;
	}
	componentWillUnmount() {
		this._ismounted = false;
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.reservations != this.state.reservations || this.state.expanded != prevState.expanded) {
			this.setState(
				this.updateTableItemsFromProps(this.props, this.state)
			);
		}
		
		if (
			this.props.accommodations            != prevProps.accommodations ||
			this.props.accommodation_items       != prevProps.accommodation_items ||
			this.props.accommodation_item_places != prevProps.accommodation_item_places
		) {
			this.setState({
				accommodation_item_place_titles: this.generateAccommodationItemPlaceTitles(
					this.props.accommodations,
					this.props.accommodation_items,
					this.props.accommodation_item_places,
				),
				accommodation_item_place_ords: this.generateAccommodationItemPlaceOrds(
					this.props.accommodations,
					this.props.accommodation_items,
					this.props.accommodation_item_places,
				),
			});
			
			this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction);
		}
		
		if (
			this.state.accommodation_item_place_titles != prevState.accommodation_item_place_titles ||
			this.state.accommodation_item_place_ords   != prevState.accommodation_item_place_ords
		) {
			this.refreshTableItemsSort(this.state.table_items_sort_field, this.state.table_items_sort_direction);
		}
	}
	
	generateAccommodationItemPlaceTitles(
		accommodations,
		accommodation_items,
		accommodation_item_places,
	) {
		const accommodation_item_place_titles = {};
		
		if (accommodations !== null && accommodation_items !== null && accommodation_item_places !== null) {
			for (let id_accommodation in accommodations) {
				for (let id_accommodation_item in accommodation_items) {
					if (accommodation_items[id_accommodation_item].id_accommodation != id_accommodation) continue;
					
					for (let id_accommodation_item_place in accommodation_item_places) {
						if (accommodation_item_places[id_accommodation_item_place].id_accommodation_item != id_accommodation_item) continue;
						
						let title = accommodations[id_accommodation].title + ' • ';
						if (accommodation_items[id_accommodation_item].title != 'default') {
							title += accommodation_items[id_accommodation_item].title + ' • ';
						}
						title += accommodation_item_places[id_accommodation_item_place].title;
						
						accommodation_item_place_titles[id_accommodation_item_place] = title;
					}
				}
			}
		}
		
		return accommodation_item_place_titles;
	}
	generateAccommodationItemPlaceOrds(
		accommodations,
		accommodation_items,
		accommodation_item_places,
	) {
		const accommodation_item_place_ords = {};
		
		if (accommodations !== null && accommodation_items !== null && accommodation_item_places !== null) {
			for (let id_accommodation in accommodations) {
				for (let id_accommodation_item in accommodation_items) {
					if (accommodation_items[id_accommodation_item].id_accommodation != id_accommodation) continue;
					
					for (let id_accommodation_item_place in accommodation_item_places) {
						if (accommodation_item_places[id_accommodation_item_place].id_accommodation_item != id_accommodation_item) continue;
						
						accommodation_item_place_ords[id_accommodation_item_place] =
							accommodations[id_accommodation].ord * 1000000 +
							accommodation_items[id_accommodation_item].ord * 10000 +
							accommodation_item_places[id_accommodation_item_place].ord;
					}
				}
			}
		}
		
		return accommodation_item_place_ords;
	}
	
	updateTableItemsFromProps(props, state) {
		const filtered_reservations = {};
		for (let id_reservation in props.reservations) {
			const reservation = props.reservations[id_reservation];
			
			filtered_reservations[id_reservation] = reservation;
		}
		
		const ids = Object.keys(filtered_reservations);
		
		let sort_ids = [];
		
		if (state !== undefined && state.table_items_sort_ids !== undefined) {
			for (let i=0; i<state.table_items_sort_ids.length; i++) {
				const id = state.table_items_sort_ids[i];
				if (ids.indexOf(id) != -1) {
					sort_ids.push(id);
				}
			}
		}
		
		for (let i=0; i<ids.length; i++) {
			const id = ids[i];
			if (sort_ids.indexOf(id) == -1) {
				sort_ids.push(id);
			}
		}
		
		const new_state = {
			reservations:                    props.reservations,
			table_items:                     filtered_reservations,
			table_items_sort_ids:            sort_ids,
			table_items_filtered_ids:        ids,
			table_items_sort_field:          state.table_items_sort_field,
			table_items_sort_direction:      state.table_items_sort_direction,
			accommodation_item_place_titles: state.accommodation_item_place_titles,
			accommodation_item_place_ords:   state.accommodation_item_place_ords,
			expanded:                        state.expanded,
		};
		
		const {
			table_items_filtered_ids,
			table_items_filters,
			table_items_sort_ids,
		} = this.filterTableItems(state.table_items_filters, new_state, true);
		
		new_state.table_items_filtered_ids = table_items_filtered_ids;
		new_state.table_items_filters      = table_items_filters;
		new_state.table_items_sort_ids     = table_items_sort_ids;
		
		return new_state;
	}
	
	setTableItemsSort(field) {
		let direction = 'ASC';
		if (this.state.table_items_sort_field == field) {
			direction = (this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC');
		}
		
		this.setState({
			table_items_sort_field:     field,
			table_items_sort_direction: direction,
		});
		
		this.refreshTableItemsSort(field, direction);
	}
	
	refreshTableItemsSort(field, direction, table_items_filtered_ids, state, return_only) {
		state                    = state || this.state;
		table_items_filtered_ids = table_items_filtered_ids || state.table_items_filtered_ids;
		
		const ids = table_items_filtered_ids;
		ids.sort((a_key, b_key) => {
			let a = '';
			let b = '';
			let dir = direction;
			
			if (field == 'accommodation') {
				const reservation_a = state.table_items[a_key];
				const reservation_b = state.table_items[b_key];
				
				a = state.accommodation_item_place_ords === undefined ? 0 :
					state.accommodation_item_place_ords[reservation_a.id_accommodation_item_place] || 0;
				b = state.accommodation_item_place_ords === undefined ? 0 :
					state.accommodation_item_place_ords[reservation_b.id_accommodation_item_place] || 0;
			}
			else if (field == 'status') {
				a = state.statuses[state.table_items[a_key].deleted === true ? 'deleted' : state.table_items[a_key][field]].title;
				b = state.statuses[state.table_items[b_key].deleted === true ? 'deleted' : state.table_items[b_key][field]].title;
				
				return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
			}
			else if (field == 'guests') {
				const reservation_a = state.table_items[a_key];
				const reservation_b = state.table_items[b_key];
				
				const customer_a = this.props.customers[reservation_a.id_customer];
				const customer_b = this.props.customers[reservation_b.id_customer];
				
				a = customer_a === undefined ? '' : (customer_a.type == 'natural' ? customer_a.surname + ' ' + customer_a.name : customer_a.company_name);
				b = customer_b === undefined ? '' : (customer_b.type == 'natural' ? customer_b.surname + ' ' + customer_b.name : customer_b.company_name);
				
				return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
			}
			else if (field == 'customer_id_country') {
				const reservation_a = state.table_items[a_key];
				const reservation_b = state.table_items[b_key];
				
				const customer_a = this.props.customers[reservation_a.id_customer];
				const customer_b = this.props.customers[reservation_b.id_customer];
				
				a = customer_a === undefined ? '' : (customer_a.id_country === null ? '' : this.props.countries[customer_a.id_country].common_name_local);
				b = customer_b === undefined ? '' : (customer_b.id_country === null ? '' : this.props.countries[customer_b.id_country].common_name_local);
				
				return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
			}
			else if (field == 'customer_id_identification_type') {
				const reservation_a = state.table_items[a_key];
				const reservation_b = state.table_items[b_key];
				
				const customer_a = this.props.customers[reservation_a.id_customer];
				const customer_b = this.props.customers[reservation_b.id_customer];
				
				a = customer_a === undefined ? '' : (customer_a.id_identification_type === null ? '' : this.props.identification_types[customer_a.id_identification_type].title);
				b = customer_b === undefined ? '' : (customer_b.id_identification_type === null ? '' : this.props.identification_types[customer_b.id_identification_type].title);
				
				return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
			}
			else if (field == 'customer_identification_number') {
				const reservation_a = state.table_items[a_key];
				const reservation_b = state.table_items[b_key];
				
				const customer_a = this.props.customers[reservation_a.id_customer];
				const customer_b = this.props.customers[reservation_b.id_customer];
				
				a = customer_a === undefined ? '' : (customer_a.identification_number ?? '');
				b = customer_b === undefined ? '' : (customer_b.identification_number ?? '');
				
				return a.localeCompare(b) * (dir == 'ASC' ? 1 : -1);
			}
			else if (field == 'guest_count') {
				a = state.table_items[a_key].guest_adult_count + state.table_items[a_key].guest_child_1_count + state.table_items[a_key].guest_child_2_count;
				b = state.table_items[b_key].guest_adult_count + state.table_items[b_key].guest_child_1_count + state.table_items[b_key].guest_child_2_count;
			}
			else if (field == 'internal_code') {
				const reservation_a = state.table_items[a_key];
				const reservation_b = state.table_items[b_key];
				
				const pos_a = reservation_a.internal_code.indexOf('.');
				const internal_code_a = pos_a === -1 ? reservation_a.internal_code : reservation_a.internal_code.substring(pos_a + 1);
				
				const pos_b = reservation_b.internal_code.indexOf('.');
				const internal_code_b = pos_b === -1 ? reservation_b.internal_code : reservation_b.internal_code.substring(pos_b + 1);
				
				const internal_code_num_a = parseInt(internal_code_a, 10);
				const internal_code_num_b = parseInt(internal_code_b, 10);
				
				if (internal_code_num_a > internal_code_num_b) {
					return 1 * (dir == 'ASC' ? 1 : -1);
				}
				else if (internal_code_num_a < internal_code_num_b) {
					return -1 * (dir == 'ASC' ? 1 : -1);
				}
				return 0;
			}
			else {
				a = state.table_items[a_key][field];
				b = state.table_items[b_key][field];
			}
			
			return (a < b ? -1 : a > b ? 1 : 0) * (dir == 'ASC' ? 1 : -1);
		});
		
		const new_state = {
			table_items_sort_ids: ids,
		};
		
		if (!return_only) {
			this.setState(new_state);
		}
		return new_state;
	}
	
	toIsoString(date) {
		const year  = date.getFullYear();
		const month = date.getMonth() + 1;
		const day   = date.getDate();
		
		return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
	}
	
	filterTableItems(filters, state, return_only) {
		state = state || this.state;
		
		const filters_id_accommodation_item_places     = filters.id_accommodation_item_places;
		const filters_statuses                         = filters.statuses;
		const filters_internal_code                    = filters.internal_code.toUpperCase();
		const filters_customer_name                    = filters.customer_name.toUpperCase();
		const filters_customer_id_countries            = filters.customer_id_countries;
		const filters_customer_id_identification_types = filters.customer_id_identification_types;
		const filters_customer_identification_number   = filters.customer_identification_number.toUpperCase();
		const filter_check_in_start                    = filters.check_in_range[0]  === null ? null : this.toIsoString(filters.check_in_range[0]);
		const filter_check_in_end                      = filters.check_in_range[1]  === null ? null : this.toIsoString(filters.check_in_range[1]);
		const filter_check_out_start                   = filters.check_out_range[0] === null ? null : this.toIsoString(filters.check_out_range[0]);
		const filter_check_out_end                     = filters.check_out_range[1] === null ? null : this.toIsoString(filters.check_out_range[1]);
		const filter_guests_checked_in                 = filters.guests_checked_in;
		
		console.log({ filter_guests_checked_in });
		
		const reservation_customers_by_id_reservations = {};
		for (let id_reservation_customer in this.props.reservation_customers) {
			const reservation_customer = this.props.reservation_customers[id_reservation_customer];
			if (reservation_customer === undefined) continue;
			
			if (reservation_customers_by_id_reservations[reservation_customer.id_reservation] === undefined) {
				reservation_customers_by_id_reservations[reservation_customer.id_reservation] = [];
			}
			
			reservation_customers_by_id_reservations[reservation_customer.id_reservation].push(reservation_customer);
		}
		
		const ids = Object.keys(state.table_items);
		const filtered_ids = ids.filter(id => {
			const item = state.table_items[id];
			
			if (filters_id_accommodation_item_places.length > 0) {
				let found = false;
				for (let i=0; i<filters_id_accommodation_item_places.length; i++) {
					if (item.id_accommodation_item_place == filters_id_accommodation_item_places[i]) {
						found = true;
						break;
					}
				}
				if (!found) {
					return false;
				}
			}
			
			if (filters_statuses.length > 0) {
				let found = false;
				for (let i=0; i<filters_statuses.length; i++) {
					if (
						(filters_statuses[i] == 'deleted' && item.deleted === true) ||
						(item.status == filters_statuses[i] && item.deleted !== true)
					) {
						found = true;
						break;
					}
				}
				if (!found) {
					return false;
				}
			}
			
			if (filters_internal_code != '') {
				if (item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) {
					return false;
				}
			}
			
			// don't filter based on guests when they are hidden
			const reservation_customers = !state.expanded ? [] : (
				reservation_customers_by_id_reservations[id] === undefined ? [] :
					Object.values(reservation_customers_by_id_reservations[id])
			);
			
			if (filters_customer_name != '') {
				const filter = (customer) => {
					if (customer === undefined || customer === null) return false;
					return (customer.surname + ' ' + customer.name + ' ' + customer.company_name)
						.toUpperCase()
						.indexOf(filters_customer_name) != -1;
				};
				let found = filter(this.props.customers[item.id_customer]);
				found = found || reservation_customers.some(x => filter(this.props.customers[x.id_customer]));
				
				if (!found) {
					return false;
				}
			}
			
			if (filters_customer_id_countries.length > 0) {
				const filter = (customer) => {
					if (customer === undefined || customer === null) return false;
					return customer.id_country !== null && filters_customer_id_countries.indexOf(customer.id_country) != -1;
				};
				let found = filter(this.props.customers[item.id_customer]);
				found = found || reservation_customers.some(x => filter(this.props.customers[x.id_customer]));
				
				if (!found) {
					return false;
				}
			}
			
			if (filters_customer_id_identification_types.length > 0) {
				const filter = (customer) => {
					if (customer === undefined || customer === null) return false;
					return customer.id_identification_type !== null && filters_customer_id_identification_types.indexOf(customer.id_identification_type) != -1;
				};
				let found = filter(this.props.customers[item.id_customer]);
				found = found || reservation_customers.some(x => filter(this.props.customers[x.id_customer]));
				
				if (!found) {
					return false;
				}
			}
			
			if (filters_customer_identification_number != '') {
				const filter = (customer) => {
					if (customer === undefined || customer === null) return false;
					return customer.identification_number !== null &&
						customer.identification_number.toUpperCase().indexOf(filters_customer_identification_number) != -1;
				};
				let found = filter(this.props.customers[item.id_customer]);
				found = found || reservation_customers.some(x => filter(this.props.customers[x.id_customer]));
				
				if (!found) {
					return false;
				}
			}
			
			if (filter_check_in_start !== null) {
				const filter = (customer) => {
					if (customer === undefined || customer === null || customer.check_in === null || customer.check_in === undefined) return false;
					
					let val = this.toIsoString(new Date(customer.check_in)) >= filter_check_in_start;
					if (val && filter_check_in_end !== null) {
						val = this.toIsoString(new Date(customer.check_in)) <= filter_check_in_end;
					}
					
					return val;
				};
				let found = filter(item);
				found = found || reservation_customers.some(x => filter(this.props.customers[x.id_customer]));
				
				if (!found) {
					return false;
				}
			}
			if (filter_check_in_end !== null) {
				const filter = (customer) => {
					if (customer === undefined || customer === null || customer.check_in === null || customer.check_in === undefined) return false;
					return /*customer.check_in === null ||*/ this.toIsoString(new Date(customer.check_in)) <= filter_check_in_end;
					
					let val = this.toIsoString(new Date(customer.check_in)) <= filter_check_in_end;
					if (val && filter_check_in_start !== null) {
						val = this.toIsoString(new Date(customer.check_in)) >= filter_check_in_start;
					}
					
					return val;
				};
				let found = filter(item);
				found = found || reservation_customers.some(x => filter(this.props.customers[x.id_customer]));
				
				if (!found) {
					return false;
				}
			}
			if (filter_check_out_start !== null) {
				const filter = (customer) => {
					if (customer === undefined || customer === null || customer.check_out === null || customer.check_out === undefined) return false;
					
					let val = this.toIsoString(new Date(customer.check_out)) >= filter_check_out_start;
					if (val && filter_check_out_end !== null) {
						val = this.toIsoString(new Date(customer.check_out)) <= filter_check_out_end;
					}
					
					return val;
				};
				let found = filter(item);
				found = found || reservation_customers.some(x => filter(this.props.customers[x.id_customer]));
				
				if (!found) {
					return false;
				}
			}
			if (filter_check_out_end !== null) {
				const filter = (customer) => {
					if (customer === undefined || customer === null || customer.check_out === null || customer.check_out === undefined) return false;
					
					let val = this.toIsoString(new Date(customer.check_out)) <= filter_check_out_end;
					if (val && filter_check_out_start !== null) {
						val = this.toIsoString(new Date(customer.check_out)) >= filter_check_out_start;
					}
					
					return val;
				};
				let found = filter(item);
				found = found || reservation_customers.some(x => filter(this.props.customers[x.id_customer]));
				
				if (!found) {
					return false;
				}
			}
			
			if (filter_guests_checked_in !== null) {
				if (item.guests_checked_in !== filter_guests_checked_in) return false;
			}
			
			return true;
		});
		
		const new_state = {
			table_items_filtered_ids: filtered_ids,
			table_items_filters:      filters,
		};
		
		if (!return_only) {
			this.setState(new_state);
		}
		
		const { table_items_sort_ids } = this.refreshTableItemsSort(
			state.table_items_sort_field,
			state.table_items_sort_direction,
			filtered_ids,
			{
				table_items_filtered_ids: new_state,
				table_items_filters:      new_state,
				table_items:              state.table_items,
				accommodation_item_place_titles: state.accommodation_item_place_titles,
				accommodation_item_place_ords:   state.accommodation_item_place_ords,
			},
			return_only
		);
		
		new_state.table_items_sort_ids = table_items_sort_ids;
		
		return new_state;
	}
	
	handleFilterChange(field_name, event) {
		const new_filters = {
			id_accommodation_item_places:     this.state.table_items_filters.id_accommodation_item_places,
			statuses:                         this.state.table_items_filters.statuses,
			internal_code:                    this.state.table_items_filters.internal_code,
			customer_name:                    this.state.table_items_filters.customer_name,
			customer_id_countries:            this.state.table_items_filters.customer_id_countries,
			customer_id_identification_types: this.state.table_items_filters.customer_id_identification_types,
			customer_identification_number:   this.state.table_items_filters.customer_identification_number,
			check_in_range:                   this.state.table_items_filters.check_in_range,
			check_out_range:                  this.state.table_items_filters.check_out_range,
			guests_checked_in:                this.state.table_items_filters.guests_checked_in,
		};
		
		let val = event;
		if (val === null) { }
		if (val instanceof Date) { }
		else if (Array.isArray(val)) { }
		else if (val instanceof Object) {
			val = event.target.value;
		}
		new_filters[field_name] = val;
		
		this.filterTableItems(new_filters);
	}
	
	openReservationDialog(id_reservation, id_reservation_customer) {
		this.setState({
			reservation_dialog_open:                    true,
			reservation_dialog_id_reservation:          id_reservation,
			reservation_dialog_id_reservation_customer: id_reservation_customer || null,
		});
	}
	closeReservationDialog() {
		this.setState({
			reservation_dialog_open:                    false,
			reservation_dialog_id_reservation:          -1,
			reservation_dialog_id_reservation_customer: null,
		});
	}
	
	openEditInvoiceDialog(type, item) {
		this.setState({
			invoice_dialog_open: true,
			invoice_dialog_type: type,
			invoice_dialog_item: item,
		});
	}
	async closeEditInvoiceDialog(item, open_create_invoice_type, finish_invoice) {
		this.setState({
			invoice_dialog_open: false,
			invoice_dialog_item: null,
		});
		
		if (item !== undefined) {
			this.props.dispatch(addInvoice({
				item,
				token: this.props.token,
			}));
			
			const dispatch = this.props.dispatch;
			const token    = this.props.token;
			
			const new_items = await saveInvoice(this.props.api_url, item, token, dispatch);
			if (new_items !== null) {
				if (new_items.invoices !== undefined) {
					dispatch(addInvoices(new_items.invoices));
				}
				if (new_items.document_associations !== undefined) {
					dispatch(addDocumentAssociations(new_items.document_associations));
				}
				if (new_items.advance_invoice_consumptions !== undefined) {
					dispatch(addAdvanceInvoiceConsumptions(new_items.advance_invoice_consumptions));
				}
				
				if (finish_invoice && this.props.document_types[item.invoice_type].fiscal_verification_enabled) {
					this.setState({
						wait_fiscal_verification_dialog_open:       true,
						wait_fiscal_verification_dialog_id_invoice: item.id_invoice,
					});
				}
			}
		}
		
		if (open_create_invoice_type !== undefined) {
			const new_item = InvoiceCreator.Duplicate(item);
			new_item.id_invoice              = uuid.v4();
			new_item.invoice_number          = '';
			new_item.invoice_number_internal = '';
			new_item.invoice_type            = open_create_invoice_type;
			new_item.draft                   = true;
			new_item.reference               = item.invoice_number_internal;
			new_item.original_id_invoice     = item.id_invoice;
			new_item.original_invoice_type   = item.invoice_type;
			new_item.note                    = '';
			
			if (open_create_invoice_type == 'prepayment-invoice') {
				new_item.invoice_date = this.toIsoString(new Date());
				new_item.payment_date = this.toIsoString(new Date());
			}
			
			for (let i=0; i<new_item.payments.length; i++) {
				new_item.payments[i].id_invoice_payment = null;
			}
			for (let i=0; i<new_item.items.length; i++) {
				new_item.items[i].id_invoice_item = uuid.v4();
			}
			
			setTimeout(() => {
				if (!this._ismounted) return;
				this.openEditInvoiceDialog(open_create_invoice_type, new_item);
			}, 1000);
		}
	}
	
	openDocumentListDialog(id_document) {
		this.setState({
			document_list_dialog_open:        true,
			document_list_dialog_id_document: id_document,
		});
	}
	closeDocumentListDialog() {
		this.setState({
			document_list_dialog_open:        false,
			document_list_dialog_id_document: null,
		});
	}
	
	render() {
		if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('reservations--list') === -1) return null;
		
		return <>
			{!this.state.invoice_dialog_open ? null :
				<EditInvoiceDialog
					closeEditInvoiceDialog={this.closeEditInvoiceDialog}
					item={this.state.invoice_dialog_item}
					type={this.state.invoice_dialog_type} />
			}
			
			{!this.state.reservation_dialog_open ? null :
				<Reservation
					closeReservation={this.closeReservationDialog}
					deleteReservation={null}
					reservation={this.props.reservations[this.state.reservation_dialog_id_reservation]}
					open_id_reservation_customer={this.state.reservation_dialog_id_reservation_customer} />
			}
			
			{!this.state.document_list_dialog_open ? null :
				<DocumentListDialog
					id_document={this.state.document_list_dialog_id_document}
					closeDialog={this.closeDocumentListDialog}
					deep={true} />
			}
			
			{!this.state.wait_fiscal_verification_dialog_open ? null :
				<WaitFiscalVerificationDialog
					closeWaitFiscalVerificationDialog={(print) => {
						this.setState({ wait_fiscal_verification_dialog_open: false });
						
						if (print) {
							const invoice = this.props.invoices[this.state.wait_fiscal_verification_dialog_id_invoice];
							if (this.props.general_settings.auto_print_type == 'a4') {
								this.props.dispatch(enqueueInvoiceOnA4PrinterQueue({ type: 'invoice', lang: 'sl', invoice }));
							}
							else if (this.props.general_settings.auto_print_type == 'pos') {
								this.props.dispatch(enqueueInvoiceOnPosPrinterQueue({ type: 'invoice', invoice }));
							}
						}
					}}
					id_invoice={this.state.wait_fiscal_verification_dialog_id_invoice} />
			}
			
			<div className='flex flex-col flex-grow reservation-list'>
				<div className='pl-4 pr-4 pt-4 flex'>
					<ButtonGroup className='mr-4'>
						<Button
							intent='success'
							icon='filter'
							onClick={() => {
								const new_filters = {
									id_accommodation_item_places:     [],
									statuses:                         [],
									internal_code:                    '',
									customer_name:                    '',
									customer_id_countries:            [],
									customer_id_identification_types: [],
									customer_identification_number:   '',
									check_in_range:                   [moment().toDate(), moment().toDate()],
									check_out_range:                  [null, null],
									guests_checked_in:                null,
								};
								
								this.filterTableItems(new_filters);
							}}>
							Prihodi danes
						</Button>
						<Button
							intent='success'
							icon='filter'
							onClick={() => {
								const new_filters = {
									id_accommodation_item_places:     [],
									statuses:                         [],
									internal_code:                    '',
									customer_name:                    '',
									customer_id_countries:            [],
									customer_id_identification_types: [],
									customer_identification_number:   '',
									check_in_range:                   [moment().add(1, 'day').toDate(), moment().add(1, 'day').toDate()],
									check_out_range:                  [null, null],
									guests_checked_in:                null,
								};
								
								this.filterTableItems(new_filters);
							}}>
							Prihodi jutri
						</Button>
					</ButtonGroup>
					<ButtonGroup className='mr-4'>
						<Button
							intent='warning'
							icon='filter'
							onClick={() => {
								const new_filters = {
									id_accommodation_item_places:     [],
									statuses:                         [],
									internal_code:                    '',
									customer_name:                    '',
									customer_id_countries:            [],
									customer_id_identification_types: [],
									customer_identification_number:   '',
									check_in_range:                   [null, null],
									check_out_range:                  [moment().toDate(), moment().toDate()],
									guests_checked_in:                null,
								};
								
								this.filterTableItems(new_filters);
							}}>
							Odhodi danes
						</Button>
						<Button
							intent='warning'
							icon='filter'
							onClick={() => {
								const new_filters = {
									id_accommodation_item_places:     [],
									statuses:                         [],
									internal_code:                    '',
									customer_name:                    '',
									customer_id_countries:            [],
									customer_id_identification_types: [],
									customer_identification_number:   '',
									check_in_range:                   [null, null],
									check_out_range:                  [moment().add(1, 'day').toDate(), moment().add(1, 'day').toDate()],
									guests_checked_in:                null,
								};
								
								this.filterTableItems(new_filters);
							}}>
							Odhodi jutri
						</Button>
					</ButtonGroup>
					<Button
						intent='primary'
						icon='filter'
						onClick={() => {
							const new_filters = {
								id_accommodation_item_places:     this.state.table_items_filters.id_accommodation_item_places,
								statuses:                         [
									'new',
									'waiting-for-confirmation',
									'offer-sent',
									'confirmed',
									'advance-invoice-sent',
								],
								internal_code:                    this.state.table_items_filters.internal_code,
								customer_name:                    this.state.table_items_filters.customer_name,
								customer_id_countries:            this.state.table_items_filters.customer_id_countries,
								customer_id_identification_types: this.state.table_items_filters.customer_id_identification_types,
								customer_identification_number:   this.state.table_items_filters.customer_identification_number,
								check_in_range:                   this.state.table_items_filters.check_in_range,
								check_out_range:                  this.state.table_items_filters.check_out_range,
								guests_checked_in:                this.state.table_items_filters.guests_checked_in,
							};
							
							this.filterTableItems(new_filters);
						}}>
						Odprte rezervacije (glede na izbrane filtre)
					</Button>
					<div className='flex-1'></div>
					<Button
						intent='primary'
						icon='expand-all'
						active={this.state.expanded}
						onClick={() => {
							this.setState({ expanded: !this.state.expanded });
						}}>
						Prikaži goste
					</Button>
				</div>
				<div className='flex-1 pl-4 pr-4'>
					<div className='flex-grow overflow-y-auto' style={{ flexBasis: '0' }}>
						<Results
							table_items=                    {this.state.table_items}
							table_items_sort_ids=           {this.state.table_items_sort_ids}
							table_items_sort_field=         {this.state.table_items_sort_field}
							table_items_sort_direction=     {this.state.table_items_sort_direction}
							setTableItemsSort=              {this.setTableItemsSort}
							tableItemsFilters=              {this.state.table_items_filters}
							originalTableItemsFilters=      {this.state.original_table_items_filters}
							handleFilterChange=             {this.handleFilterChange}
							reservation_customers=          {this.props.reservation_customers}
							customers=                      {this.props.customers}
							accommodations=                 {this.props.accommodations}
							accommodation_items=            {this.props.accommodation_items}
							accommodation_item_places=      {this.props.accommodation_item_places}
							countries=                      {this.props.countries}
							accommodation_item_place_titles={this.state.accommodation_item_place_titles}
							statuses=                       {this.state.statuses}
							identification_types=           {this.props.identification_types}
							openReservationDialog=          {this.openReservationDialog}
							guest_book_items=               {this.props.guest_book_items}
							document_associations=          {this.props.document_associations}
							invoices=                       {this.props.invoices}
							openEditInvoiceDialog=          {this.openEditInvoiceDialog}
							expanded=                       {this.state.expanded}
							openDocumentListDialog=         {this.openDocumentListDialog} />
					</div>
				</div>
			</div>
		</>;
	}
}
ReservationList.propTypes = {
};

function mapStateToProps(state) {
	return {
		customers:                 state.CodeTablesSlice.customers,
		reservations:              state.ReservationSlice.reservations,
		reservation_customers:     state.ReservationSlice.reservation_customers,
		api_url:                   state.ReservationSlice.api_url,
		token:                     state.UserSlice.token,
		user:                      state.UserSlice.user,
		accommodations:            state.CodeTablesSlice.accommodations,
		accommodation_items:       state.CodeTablesSlice.accommodation_items,
		accommodation_item_places: state.CodeTablesSlice.accommodation_item_places,
		countries:                 state.CodeTablesSlice.countries,
		identification_types:      state.CodeTablesSlice.identification_types,
		guest_book_items:          state.GuestSlice.guest_book_items,
		document_associations:     state.DocumentSlice.document_associations_id_documents,
		invoices:                  state.BusinessSlice.invoices,
		document_types:            state.DocumentSlice.document_types,
		general_settings:          state.SettingsSlice.general,
	};
}

export default connect(mapStateToProps)(ReservationList);
